import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const RefExtractor = () => {
  const faqs = [
    {
      question: "Q: What does the Reference Extractor module do ?",
      answer:
        "A: It scans uploaded documents, identifies patent and non-patent literature (NPL) references, and highlights them.",
    },
    {
      question: "Q: Which file formats are supported ?",
      answer: "A: PDF, DOC, and DOCX.",
    },
    {
      question: "Q: Can I upload multiple documents ?",
      answer: "A: Yes, up to a combined size of 25 MB.",
    },
    {
      question: "Q: What do the highlight colors mean ?",
      answer:
        "A: Patent and NPL references = Yellow.\nQ: Duplicate references = Green.",
    },
    {
      question: "Q: Does the module provide a full list of references ?",
      answer:
        "A: Not separately. PDF outputs include bookmarks listing references, their locations, and clickable links.",
    },
    {
      question: "Q: Why is my output sometimes PDF and sometimes Word ?",
      answer:
        "A: The output keeps the same format as the uploaded file.",
    },
    {
      question: "Q: Why do not I see bookmarks in my Word file ?",
      answer:
        "A: Bookmarking is currently supported only for PDFs.",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": { margin: 0 },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ whiteSpace: "pre-line" }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default RefExtractor;
